<template>
  <div class="calendar">
    <div class="fixedDate">
        <p @click="getdate(0)">今天</p>
        <p @click="getdate(1)">昨天</p>
        <p @click="getdate(2)">过去7天</p>
        <p @click="getdate(3)">过去30天</p>
        <p @click="getdate(4)">本周</p>
        <p @click="getdate(5)">本月</p>
        <p @click="getdate(6)">上月</p>
    </div>
    <div class="selectDate">
        <div class="datebox">
            <div class="yearMonth">
                <div class="icon iconLeft">
                    <i class="el-icon-d-arrow-left" @click="prevyear"></i>
                    <i class="el-icon-arrow-left" @click="prevmonth"></i>
                </div>
                <span >{{date[0].year}}年{{date[0].month}}月</span>
            </div>
            <div class="date">
                <ul class="datetitle">
                    <li>日</li>
                    <li>一</li>
                    <li>二</li>
                    <li>三</li>
                    <li>四</li>
                    <li>五</li>
                    <li>六</li>
                </ul>
                <ul class="dateday">
                    <li v-for="(item,index) in date[0].dayList" :key="index" :class="[timedate.indexOf(item.date)!=-1&&date[0].month==item.month?'on':'',date[0].month!=item.month?'gray':'nogray',colorclass(item)?'blue':'']">
                        <span @click="selectTimeSimple(item)">{{item.day}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="datebox">
            <div class="yearMonth">
                <div class="icon iconRight">
                    <i class="el-icon-arrow-right" @click="nextmonth"></i>
                    <i class="el-icon-d-arrow-right" @click="nextyear"></i>
                </div>
                <span>{{date[1].year}}年{{date[1].month}}月</span>
            </div>
            <div class="date">
                <ul class="datetitle">
                    <li>日</li>
                    <li>一</li>
                    <li>二</li>
                    <li>三</li>
                    <li>四</li>
                    <li>五</li>
                    <li>六</li>
                </ul>
                <ul class="dateday">
                    <li v-for="(item,index) in date[1].dayList" :key="index" :class="[timedate.indexOf(item.date)!=-1&&date[1].month==item.month?'on':'',date[1].month!=item.month?'gray':'nogray',colorclass(item)?'blue':'']">
                        <span @click="selectTimeSimple(item)"  >{{item.day}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
var _this
import {
    getDay,
    getNowMonth,
    getLastMonth,
    getWeekTime
} from "@/util/fun.js"
export default {
    props:{
        start_time:{
          default: ""
        },
        end_time:{
          default: ""
        }
    },
    data(){
        return {
            timedate:[],
            timeIndex:0,
            date:[
                {
                    weeks:"",//多少周
                    week:"",//第一天周几
                    year:"",
                    month:"",
                    day:"",
                    dayList:[]//天数
                },
                {
                    weeks:"",//多少周
                    week:"",//第一天周几
                    year:"",
                    month:"",
                    day:"",
                    dayList:[]//天数
                }
            ],
            startTime:"",
            endTime:"",
            status:true,
        }
    },
    mounted() {
        _this = this
        this.timedate[0] = _this.start_time
        this.timedate[1] = _this.end_time
        var time = this.timedate[0].split('.');
        let current  = [
            Number(time[0]),
            Number(time[1]),
        ];
        var last

        if(time[1]== 12){
            last = [
                Number(time[0]) + 1,
                1,
            ];
        }else{
            last = [
                Number(time[0]),
                Number(time[1])+1
            ];
        }
        _this.countDay(current,0)
        _this.countDay(last,1)
    },
    methods: {
        colorclass(data){
            // _this.$nextTick(function(){
                let str1 = this.timedate[0].split('.')
                let str2 = this.timedate[1].split('.')
                let str3 = data.date.split('.')

                str1.forEach((item,index)=>{
                    if(Number(item)<10){
                        str1[index] = '0'+item
                    }
                })

                str2.forEach((item,index)=>{
                    if(Number(item)<10){
                        str2[index] = '0'+item
                    }
                })

                str3.forEach((item,index)=>{
                    if(Number(item)<10){
                        str3[index] = '0'+item
                    }
                })
                str1 = str1.join("")
                str2 = str2.join("")
                str3 = str3.join("")
                // console.log(str1,str2,str3)
                // console.log(str3>str1,str3<str2)
                if(str3>str1&&str3<str2){
                    return true
                }else{
                    return false
                }
            // })
        },
        getdate(index){
            switch (index) {
                case 0:
                    this.endTime = getDay(0)
                    this.startTime = getDay(0) //今天
                    break;
                case 1:
                    this.endTime = getDay(-1)
                    this.startTime = getDay(-1) //昨天
                    break;
                case 2:
                    this.endTime = getDay(0)
                    this.startTime = getDay(-7) //近7天
                    break;
                case 3:
                    this.endTime = getDay(0)
                    this.startTime = getDay(-30) //近30
                    break;
                case 4:
                    this.endTime = getWeekTime()[1]//本周
                    this.startTime = getWeekTime()[0]
                    break;
                case 5:
                    this.endTime = getDay(0)
                    this.startTime = getNowMonth() //本月
                    break;

                case 6:
                    this.endTime = getLastMonth()[1]//上月
                    this.startTime = getLastMonth()[0]
                    break;
            }
            let time = []
            time.push(this.startTime,this.endTime)
            this.$emit('selectTime', time);
        },
        prevyear(){
            let current  = [
                _this.date[0].year-1,
                _this.date[0].month,
            ];
            var last


            last = [
                _this.date[1].year-1,
                _this.date[1].month,
            ];

            _this.countDay(current,0)
            _this.countDay(last,1)
        },
        prevmonth(){
            let current
            if(_this.date[0].month==1){
                current  = [
                    _this.date[0].year-1,
                    12,
                ];
            }else{
                current  = [
                    _this.date[0].year,
                    _this.date[0].month-1,
                ];
            }
            var last
            if(_this.date[1].month==1){
                last = [
                    _this.date[0].year,
                    12,
                ];
            }else{
                last = [
                    _this.date[0].year,
                    _this.date[1].month-1,
                ];
            }
          _this.countDay(current,0)
            _this.countDay(last,1)
        },
        nextyear(){
            let current  = [
                _this.date[0].year+1,
                _this.date[0].month,
            ];
            var last


            last = [
                _this.date[1].year+1,
                _this.date[1].month,
            ];

            _this.countDay(current,0)
            _this.countDay(last,1)
        },
        nextmonth(){
            let current
            if(_this.date[0].month==12){
                current  = [
                    _this.date[0].year+1,
                    1,
                ];
            }else{
                current  = [
                    _this.date[0].year,
                    _this.date[0].month+1,
                ];
            }
            var last
            if(_this.date[1].month==12){
                last = [
                    _this.date[1].year+1,
                    1,
                ];
            }else{
                last = [
                    _this.date[0].year,
                    _this.date[1].month+1,
                ];
            }
            _this.countDay(current,0)
            _this.countDay(last,1)
        },

      /**
       * 简单的处理时间选择逻辑
       * @param data 选择的时间
       */
        selectTimeSimple(data) {
          _this.timeIndex++;
          if (_this.timeIndex == 1) {
            _this.$set(_this.timedate,0,data.date)
          } else {
            _this.$set(_this.timedate,1,data.date)
            _this.status = !_this.status;
            if(_this.timeIndex > 1){
              this.$emit('selectTime', Object.assign({}, _this.timedate));
            }
          }
        },

        selectTime(data){
            _this.timeIndex++
            let str1 = _this.supplementZero(_this.timedate[0]);
            let str2 = _this.supplementZero(_this.timedate[1]);
            let str3 = _this.supplementZero(data.date);
            _this.$nextTick(function(){
                let startBetween = _this.calculateCrossYearBetweenDays(str1, str3);
                let endBetween = _this.calculateCrossYearBetweenDays(str2, str3);
                if(startBetween < endBetween){
                    _this.$set(_this.timedate,0,data.date)
                } else if (startBetween > endBetween){
                    _this.$set(_this.timedate,1,data.date)
                } else {
                  if (str1 - str3 > 0) {
                    _this.$set(_this.timedate,0,data.date);
                  } else {
                    _this.$set(_this.timedate,1,data.date);
                  }
                }
                _this.status = !_this.status;
                if(_this.timeIndex > 1){
                  this.$emit('selectTime', Object.assign({}, _this.timedate));
                }
            })
        },

        /**
        * 补0
        */
        supplementZero(str) {
          let strs = str.split('.');
          strs.forEach((item,index)=>{
            if(Number(item)<10){
              strs[index] = '0'+item
            }
          })
          return strs.join("");
        },

        /**
         * 支持处理跨年，计算时间相隔天数
         */
        calculateCrossYearBetweenDays(start, end) {
            if (start-end > 0) {
              let z = start;
              start = end;
              end = z;
            }
            let startYear = start.substring(0, 4);
            let endYear = end.substring(0, 4);
            if (startYear === endYear) {
              return _this.calculateMonthBetweenDays(start, end);
            }
            let betweenDays = 0;
            for (let i = startYear; i <= endYear; i++) {
              if (i == startYear) {
                betweenDays += _this.calculateMonthBetweenDays(start, startYear + "1231");
              } else if (i == endYear) {
                betweenDays += _this.calculateMonthBetweenDays(i + "0101", end);
              } else {
                // 判断是不是闰年 2月29天
                if (i % 4 === 0 && (i % 100 !== 0 || i % 400 === 0)) {
                  betweenDays += 366;
                } else {}
                betweenDays += 365;
              }
            }
            return betweenDays;
        },

      /**
       * 计算同一年的2个时间相隔的天数，注意end>start
       *
       * @param start 开始时间: 20231212
       * @param end 结束时间: 20231230
       */
        calculateMonthBetweenDays(start, end, year) {
          if (start.length == 8) {
            start = start.substring(4);
            year = start.substring(0, 4);
          }
          if (end.length == 8) {
            end = end.substring(4);
            year = start.substring(0, 4);
          }
          let startMonth= start.substring(0, 2);
          let startDay = start.substring(2);
          let endMonth = end.substring(0, 2);
          let endDay = end.substring(2);
          if (startMonth === endMonth) {
            return endDay - startDay;
          }
          let betweenDays = 0;
          for (let i = startMonth; i < endMonth; i++) {
            if (i == startMonth) {
              let remainDays = _this.getDays(year, startMonth);
              betweenDays += (remainDays - startDay);
            } else if (i == endMonth) {
              betweenDays += endDay;
            } else {
              let remainDays = _this.getDays(year, startMonth);
              betweenDays = remainDays;
            }
          }
          return betweenDays;
        },

        // 计算显示的天数据
        countDay(data,num) {
            _this.date[num].dayList = []
            let [y,m,d] = data;
            _this.date[num].year = y
            _this.date[num].month = m
            // 获取第一天是周几
            let week = new Date(`${y}/${m}/1`).getDay(),
                // 获取当前月的上个月多少天
                lastDays = _this.getDays(y, m - 1),
                // 获取这个月有多少天
                days = _this.getDays(y, m);
            _this.date[num].day = days
            // 计算这个月有多少周
            _this.date[num].weeks = Math.ceil((days - (7 - week)) / 7) + 1;
            // 将当前月份的天数生成数组
            _this.date[num].dayList = Array.from({ length: _this.getDays(y, m) }, (v, k) => {
                return {
                    day: k + 1,
                    month: m,
                    year: y,
                    date:y+'.'+m+'.'+(k+1)
                };
            });
            // 将本月1日前的数据补齐
            for (let i = lastDays; i > lastDays - week; i--) {
                _this.date[num].dayList.unshift({
                    day: i,
                    // 如果当前日期是1月补齐的是去年12月的数据
                    month: +m - 1 === 0 ? 12 : +m - 1,
                    year: +m - 1 === 0 ? y - 1 : y,
                    date:(+m - 1 === 0 ? y - 1 : y)+'.'+(+m - 1 === 0 ? 12 : +m - 1)+'.'+i
                });
            }
            // 计算需要补齐多少天
            let length = _this.date[num].weeks * 7 - _this.date[num].dayList.length;

            // 将本月最后一天的数据补齐
            for (let i = 1; i <= length; i++) {
                _this.date[num].dayList.push({
                    day: i,
                    // 如果当前日期是12月补齐的是明年年1月的数据
                    month: +m + 1 > 12 ? 1 : +m + 1,
                    year: +m + 1 > 12 ? y + 1 : y,
                    date:(+m + 1 > 12 ? y + 1 : y)+'.'+(+m + 1 > 12 ? 1 : +m + 1)+'.'+i
                });
            }
        },
        // 获取某个月有多少天
        getDays(year, month) {
            // 一年中每个月的天数
            let days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            // 判断是不是闰年 2月29天
            if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
                days[1] = 29;
            }
            return days[month - 1];
        },
    }
}
</script>

<style lang="less">
    .calendar{
        width: 600px;
        box-shadow: 2px 2px 7px  rgba(0, 0, 0, 0.25);
        display: flex;
        background-color: #fff;
        .fixedDate{
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            border-right: 1px solid #e5e5e5;
            p{
                padding: 8px;
                cursor: pointer;
            }
        }
        .selectDate{
            flex: 1 0 1%;
            display: flex;
            .datebox{
                flex: 0 0 50%;
                .yearMonth{
                    background-color:#FBFCFC;
                    padding: 10px 0;
                    border-bottom: 1px solid #e5e5e5;
                    font-size: 14px;
                    font-weight: 800;
                    color: rgba(0, 0, 0, 1);
                    text-align: center;
                    position: relative;
                    .icon{
                        position: absolute;
                    }
                    .iconLeft{
                        top: 50%;
                        transform: translateY(-50%);
                        left: 10px;
                    }
                    .iconRight{
                        top: 50%;
                        transform: translateY(-50%);
                        right: 10px;
                    }
                    i{
                        cursor: pointer;
                    }
                }
                .date{
                    padding: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    // border-right: 1px solid #e5e5e5;
                    .datetitle{
                        display: flex;
                        // justify-content: space-between;
                        margin-bottom: 10px;
                        li{
                            width: 31.7px;
                            text-align: center;
                        }
                    }
                    .dateday{
                        display: flex;
                        flex-wrap: wrap;
                        li{
                            width: 31.7px;
                            text-align: center;
                            margin-bottom: 10px;
                            span{
                                padding: 4px 0;
                                display: inline-block;
                                width: 80%;
                                height: 100%;
                            }
                        }
                        .nogray{
                            cursor: pointer;
                        }
                        .nogray:hover{
                            background-color: rgba(0, 30, 192, 1);
                            color: #fff;
                            border-radius: 4px;
                        }
                        .on{
                            background-color: rgba(0, 30, 192, 1);
                            color: #fff;
                            border-radius: 4px;
                        }
                        .gray{
                            color: #ddd!important;
                            background-color: #fff!important;
                        }
                        .blue{
                            background-color: #f4f4f5;
                            color: #2a55e5;
                        }
                    }
                }
            }
        }
    }
</style>
